var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-link"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('v-card', {
    staticClass: "main-link-card",
    attrs: {
      "img": "/images/main/main-link-bg.jpg",
      "href": "/#efesta"
    }
  }, [_c('div', {
    staticClass: "main-link-card__inner"
  }, [_c('div', {
    staticClass: "main-link-card__number mb-20px mb-xl-40px",
    staticStyle: {
      "background-image": "url(/images/main/01.svg)"
    }
  }), _c('h2', {
    staticClass: "tit tit--xxl"
  }, [_vm._v("e커머스"), _c('br'), _vm._v("피칭페스타")]), _c('div', {
    staticClass: "main-link-card__arrow"
  }, [_c('icon-arrow-rounded', {
    staticClass: "white--text",
    attrs: {
      "direction": "right"
    }
  })], 1)])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('v-card', {
    staticClass: "main-link-card",
    attrs: {
      "img": "/images/main/main-link-bg2.jpg",
      "href": "/#circulation"
    }
  }, [_c('div', {
    staticClass: "main-link-card__inner"
  }, [_c('div', {
    staticClass: "main-link-card__number mb-20px mb-xl-40px",
    staticStyle: {
      "background-image": "url(/images/main/02.svg)"
    }
  }), _c('h2', {
    staticClass: "tit tit--xxl"
  }, [_vm._v("유통데이터"), _c('br'), _vm._v("활용 경진대회")]), _c('div', {
    staticClass: "main-link-card__arrow"
  }, [_c('icon-arrow-rounded', {
    staticClass: "white--text",
    attrs: {
      "direction": "right"
    }
  })], 1)])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }